import HeaderSection from '../../components/home/HeaderSection';
import FooterSection from '../../components/home/FooterSection';
import ProfileHelpPage from '../Profile/ProfileHelpPage';

function ContactPage() {
  return (
    <>
      <HeaderSection />
      <ProfileHelpPage />
      <FooterSection />
    </>
  );
}

export default ContactPage;
